import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageField,
  Toolbar,
  ListButton,
  FileInput,
  SaveButton,
  ImageInput,
} from "react-admin";
import { onAddonandVideoTaskLabelCreate } from "../../Service/Validation/AddonandVideoTaskLabelValidation";
import Grid from "@material-ui/core/Grid";
import { RichTextInput } from 'ra-input-rich-text';
import { LabelTypeSelectInput, LabelIdSelectInput, LabelTaskSelectInput } from "../../UI/Input/SelectInput";
const PageTitle = () => {
  return <span>Create Labels</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const MerchantIntentTesterLablesCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges redirect="list" >
        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} md={12} lg={12}>
            <FileInput source="image" label="Upload Image" accept="image/*">
              <ImageField source="src" title="title" />
            </FileInput>
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Title" source="title" fullWidth />
          </Grid>
          <hr></hr>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Product URL" source="product_url" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Label 1" source="radio_label1" fullWidth />
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <TextInput label="Label 2" source="radio_label2" fullWidth />
          </Grid>
          <hr></hr>
           <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Text Input Title" source="text_field_title" fullWidth />
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextInput label="Text Input" source="text_field_value" fullWidth />
          </Grid>
        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default MerchantIntentTesterLablesCreate;
